<template>
  <v-layout row justify-space-between>
    <v-flex class='chart' xs12>
      <chart-sankey :data="data" :config="config"/>
    </v-flex>
  </v-layout>
</template>

<script>
import { ChartSankey } from 'vue-d2b'
import { sankeyLeft } from 'd3-sankey'

export default {
  name: 'ActivitiesOverviewSankey',
  components: {
    ChartSankey
  },
  data () {
    return {
      loading: false,
      dateRange: {
        format: 'YYYY-MM-DD',
        options: ['Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Custom...'],
        defaultOption: 'Last 30 days',
        value: {}
      },
      data: {
        nodes: [
          { name: 'Credentials created/updated' },
          { name: 'Login authentication successfully', color: 'green' },
          { name: 'Login authentication failure', color: 'red' },
          { name: 'Game assessment begun', color: 'blue' },
          { name: 'Game assessment completed' },
          { name: 'Users assessment ready for scoring' },
          { name: 'Users assessment scored' },
          { name: 'ATS confirms successful receipt of user score' }
        ],
        links: [
          { source: 'Credentials created/updated', target: 'Login authentication successfully', value: 100 },
          { source: 'Credentials created/updated', target: 'Login authentication failure', value: 20 },
          { source: 'Login authentication successfully', target: 'Game assessment begun', value: 80 },
          { source: 'Game assessment begun', target: 'Game assessment completed', value: 70 },
          { source: 'Game assessment completed', target: 'Users assessment ready for scoring', value: 60 },
          { source: 'Users assessment ready for scoring', target: 'Users assessment scored', value: 50 },
          { source: 'Users assessment scored', target: 'ATS confirms successful receipt of user score', value: 40 }
        ]
      },
      config (config) {
        config
          .sankey()
          .sankey()
          .nodePadding(50)

        config
          .sankey()
          .sankey()
          .nodeAlign(sankeyLeft)
      }
    }
  }
}
</script>

<style lang="sass">
.chart
  width: 100%
  height: 500px

  /* media query to force hide breadcrumbs when the screen is too small */
@media screen and (max-width: 500px)
  .d2b-breadcrumbs-frame
    display: none
    width: 0px !important
</style>
